import type { State } from '../../types';
import { employeesNotDeleted } from './employees-not-deleted';
import { employeesDeleted } from './employees-deleted';

export function employeeOptions(state: State, selected: string | undefined = undefined, includeAll: boolean = false) {
  const options = employeesNotDeleted(state)
    .filter((e) => {
      return e.status !== 'TERMINATED' && e.isConfirmedEntity && (includeAll || e.accessLevel === 'USER');
    })
    .map((e) => {
      return { value: e.uuid, text: e.name };
    });
  if (selected) {
    const selectedIncluded = options.find((o) => {
      return o.value === selected;
    });
    if (!selectedIncluded) {
      const selectedEmployee = employeesNotDeleted(state)
        .concat(employeesDeleted(state))
        .find((e) => {
          return e.uuid === selected;
        });
      if (selectedEmployee) {
        options.push({ value: selectedEmployee.uuid, text: selectedEmployee.name });
      }
    }
  }
  return options;
}
